import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {Msal2Provider} from '@microsoft/mgt-msal2-provider';
import { LoginType, Providers } from '@microsoft/mgt-react';

Providers.globalProvider = new Msal2Provider({
  clientId: process.env.REACT_APP_CLIENTID || '',
  authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AUTHORITYID}`,
  scopes: ['user.read', 'openid', 'profile', 'Directory.AccessAsUser.All'],
  loginType: LoginType.Redirect
});

ReactDOM.render(
    <App />,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
